import path from 'path';

/**
 * Create function to return the asset full path.
 */
export var createAssetPath = function createAssetPath(assetEndpoint, manifestContent) {
  var assetPrefix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  return function (assetKey) {
    var assetFile = manifestContent[assetKey] || path.join(assetPrefix, assetKey);
    return path.join(assetEndpoint, assetFile);
  };
};